export default __webpack_public_path__ + "static/Luithle_Luithle-1bcd9f600f239b1dbbc71a3cc68ef770.svg";